import { EnvironmentProviders, Provider } from '@angular/core';
import { FpLoggerNoiseSpectrumStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spectrum/services/fp-logger-noise-spectrum/fp-logger-noise-spectrum.store';
import { FpLoggerNoiseSpectrumChartService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spectrum/services/fp-logger-noise-spectrum-chart.service';
import { FpLoggerNoiseSpectrumExportService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spectrum/services/fp-logger-noise-spectrum-export.service';
import { FpLoggerNoiseSpectrumConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spectrum/services/fp-logger-noise-spectrum-connect.service';
import { FP_LOGGER_NOISE_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/providers/fp-logger-noise-tab-connect-services.token';

export function fpLoggerNoiseSpectrumProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpLoggerNoiseSpectrumStore,
    FpLoggerNoiseSpectrumChartService,
    FpLoggerNoiseSpectrumExportService,
    FpLoggerNoiseSpectrumConnectService,
    {
      provide: FP_LOGGER_NOISE_TAB_CONNECT_SERVICES,
      useExisting: FpLoggerNoiseSpectrumConnectService,
      multi: true,
    },
  ];
}
